/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import DataTable from 'react-data-table-component';

type PropsType = {
  viewTab?: string,
  progressPending: boolean,
  handleSort: () => void,
  maxResultCount: number,
  setMaxResultCount: (number) => void,
  totalRows: number,
  handlePageChange: (number) => void,
  currentPage: number,
  data: []
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

let mock = {
  columns: [],
  data: []
};

const PayoutsPageBodyBody = ({
  viewTab,
  data,
  progressPending,
  handleSort,
  maxResultCount,
  setMaxResultCount,
  totalRows,
  handlePageChange,
  currentPage
}: PropsType): React.Element<'div'> => {
  try {
    mock = require(`./tableHeaders/${
      _.toString(viewTab) === '' ? 'payments.js' : `${_.toString(viewTab)}.js`
    }`);
  } catch (e) {
    console.warn(`File "./tableHeaders/${_.toString(viewTab)}" doesn't exist`);
  }

  const CustomLoader = (): React.Element<'div'> => (
    <div className="csspinner" style={{ width: '50px', height: '50px' }} />
  );

  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            columns={mock.columns}
            data={data}
            customStyles={customStyles}
            sortServer
            onSort={(column, sortDirection) => handleSort(column.selector, sortDirection)}
            defaultSortField={viewTab === 'payments' ? 'payout_transaction_event_created_time_utc' : 'payout_event_created_time_utc'}
            highlightOnHover
            pointerOnHover
            responsive
            striped
            fixedHeader
            noHeader
            progressPending={progressPending}
            progressComponent={<CustomLoader />}
            sortIcon={(): React.Element<typeof React.Fragment> =>  (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
            )}
            pagination
            paginationPerPage={maxResultCount}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationRowsPerPageOptions={[100, 500, 1000]}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={setMaxResultCount}
          />
        </div>
      </div>
    </div>
  );
};

export default PayoutsPageBodyBody;
